import { required } from '@ps/web-shared-validators';
import React from 'react';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTCLI_Document_Description,
  TXTCLI_Please_enter_your_primary_iden_ELL_6
} from './DocumentDescriptionField.messages.json';

const DocumentDescriptionField: React.FC = () => (
  <TextInput
    id="docOtherTypeName"
    maxLength={20}
    label={TXTCLI_Document_Description}
    validators={[required(TXTCLI_Please_enter_your_primary_iden_ELL_6)]}
    checkDisabled
  />
);

export default DocumentDescriptionField;
